import React from "react";
import { AlertModalProps } from "components/v2/Modals/AlertModal/types/AlertModalProps";
import Button from "components/v2/Button/Button";
import classes from "./AlertModal.module.scss";
import BlurBackground from "components/v2/Modals/ModalBackground/BlurBackground";
import NoActionModal from "components/v2/Modals/NoActionModal";
import Icons from "assets/icons/v2/AlertModals/Icons";
import Modal from "components/v2/Modals/Modal";
import ModalBackground from "components/v2/Modals/ModalBackground/ModalBackground";
import { DetailsIcons } from "assets/icons/v2/OnlineCommands/Details/DetailsIcons";

//TODO: This component  should be refactored
const AlertModal: React.FC<AlertModalProps> = ({
  content,
  type,
  onClose,
  isOpen,
  twoOptionsAlert,
  actionOneButtonText,
  actionTwoButtonText,
  actionOne,
  actionTwo,
  hasTitle,
  hasIcon,
  title,
  hasButton,
  thirdAction,
  hasThirdAction,
  clickable,
}) => {
  const renderAlertModalContent = () => {
    return (
      <div>
        {hasTitle && (
          <div
            className={
              hasIcon
                ? classes["title-with-icon"]
                : type === "choose-warranty"
                ? classes.title
                : type === "choose-tracker"
                ? classes.title
                : ""
            }
          >
            {title}
          </div>
        )}
        <div
          className={
            clickable
              ? classes["alert-content-with-icon-clickable"]
              : hasIcon
              ? classes["alert-content-with-icon"]
              : classes["alert-content"]
          }
          onClick={() => {
            if (content && clickable) {
              if (
                typeof content === "string" &&
                (content.includes("http") || content.includes("https"))
              ) {
                window.open(content as string, "_blank");
              }
            }
          }}
        >
          {content}
        </div>
        {hasButton && (
          <div className={classes.actions}>
            <Button
              text={actionOneButtonText}
              type="secondary"
              onClick={actionOne}
              additionalStyles={classes.button}
            />
            {twoOptionsAlert && (
              <Button
                text={actionTwoButtonText}
                type="basic"
                onClick={actionTwo}
                additionalStyles={classes.button}
              />
            )}
          </div>
        )}
      </div>
    );
  };
  const renderAlertModalDetails = () => {
    if (type === "success") {
      return (
        <div>
          {hasIcon && <Icons.SuccessIcon />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "success2") {
      return (
        <div>
          {hasIcon && <Icons.SuccessIconWithBackground />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "failed") {
      return (
        <div>
          {hasIcon && <Icons.FailedIconWithBackground />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "failed2") {
      return (
        <div>
          {hasIcon && <Icons.FailedIconWithBackground />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "warning") {
      return (
        <div>
          {hasIcon && <Icons.WarningIcon />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "info") {
      return (
        <div>
          {hasIcon && <Icons.InfoIcon />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "noConnection") {
      return (
        <div>
          {hasIcon && <Icons.NoConnectionIcon />}
          {renderAlertModalContent()}
        </div>
      );
    } else if (type === "loading") {
      return (
        <div>
          <Icons.LoadingSpinner />
          <div className={classes["loading-title"]}>{title}</div>
        </div>
      );
    } else if (type === "loadingWithAction") {
      return (
        <div>
          <Icons.LoadingSpinner />
          <div className={classes["loading-title"]}>{title}</div>
          <div className={classes["alert-content-with-icon"]}>{content}</div>
          <div className={classes.actions}>
            <Button
              text={actionOneButtonText}
              type="basic"
              onClick={actionOne}
              additionalStyles={classes.button}
            />
          </div>
        </div>
      );
    } else if (type === "commands") {
      return (
        <div className={classes["commands-content"]}>
          <div className={classes["commands-header"]}>
            <div className={classes["commands-title"]}>{title}</div>
            {hasThirdAction && <DetailsIcons.Refresh onClick={thirdAction} />}
          </div>
          <div>{content}</div>
          {hasButton && (
            <div className={classes.actions}>
              <Button
                text={actionOneButtonText}
                type="secondary"
                onClick={actionOne}
                additionalStyles={classes.button}
              />
              {twoOptionsAlert && (
                <Button
                  text={actionTwoButtonText}
                  type="basic"
                  onClick={actionTwo}
                  additionalStyles={classes.button}
                />
              )}
            </div>
          )}
        </div>
      );
    } else if (type === "choose-warranty" || type === "choose-tracker") {
      return renderAlertModalContent();
    }
  };
  if (type === "loading") {
    return (
      <BlurBackground isOpen={isOpen} onClose={onClose}>
        <NoActionModal
          isOpen={isOpen}
          onClose={onClose}
          additionalClassNames={classes["alert-modal-loading"]}
        >
          {renderAlertModalDetails()}
        </NoActionModal>
      </BlurBackground>
    );
  } else if (type === "choose-tracker") {
    return (
      <ModalBackground isOpen={isOpen} onClose={onClose}>
        <NoActionModal
          isOpen={isOpen}
          onClose={onClose}
          additionalClassNames={classes["choose-tracker"]}
        >
          {renderAlertModalDetails()}
        </NoActionModal>
      </ModalBackground>
    );
  } else if (type === "choose-warranty") {
    return (
      <ModalBackground isOpen={isOpen} onClose={onClose}>
        <NoActionModal
          isOpen={isOpen}
          onClose={onClose}
          additionalClassNames={classes["choose-warranty"]}
        >
          {renderAlertModalDetails()}
        </NoActionModal>
      </ModalBackground>
    );
  } else if (type === "commands") {
    return (
      <ModalBackground isOpen={isOpen} onClose={onClose}>
        <NoActionModal
          isOpen={isOpen}
          onClose={onClose}
          additionalClassNames={classes["commands"]}
        >
          {renderAlertModalDetails()}
        </NoActionModal>
      </ModalBackground>
    );
  } else {
    return (
      <ModalBackground onClose={onClose} isOpen={isOpen}>
        <Modal
          onClose={onClose}
          isOpen={isOpen}
          additionalClassNames={classes["alert-modal"]}
        >
          {renderAlertModalDetails()}
        </Modal>
      </ModalBackground>
    );
  }
};
export default AlertModal;
